// src/services/llm-tool-call-api.ts
// API client for fetching LLM tool call details (for the chat tool-call drawer).

import api from './api';
import type { LLMToolCallDetail } from '../types/llmToolCall';

export const llmToolCallApi = {
  getToolCall: async (toolCallId: string): Promise<LLMToolCallDetail> => {
    const response = await api.get(`/api/v2/chat/tool-calls/${toolCallId}`);
    return response.data.data;
  },
};

export default llmToolCallApi;
